<div *ngIf="isInProgress">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6"></div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">Models Out Of Stock Report</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>
    <div class="row mr-1">
      <div class="col-md-11">

      </div>
      <div class="col-md-1">
        <div class="row">
          <button type="submit" class="btn btn-success" (click)="exportToPdf()"><i class="fa fa-file-pdf" aria-hidden="true">&nbsp;</i>Export to PDF</button>
        </div>
      </div>
    </div>
  </section>
      <!-- /.content-header -->
  <section class="content">
    <div class="container-fluid" id="pspdfkit-container" style="width: 100%; height: 100vh">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title text-center w-100"><b>Models Out Of Stock Report</b></h3>
            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
              {{errorMessage}}
            </div>
              <!--Warning Message-->
            <div class="alert alert-warning" role="alert" *ngIf="warningMessage">
              {{warningMessage}}
            </div>
        </div>
        <!-- /.card-header -->
        <div class="card-body" style="overflow-x: auto; overflow-y: auto; white-space: nowrap; height: 650px;">
          <!--Error messages here-->
          <table id="example1" class="table table-bordered table-hover table-striped">
            <thead>
              <tr>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Units In Stock</th>
                  <th>Units At CFS</th>
                  <th>Units Enroute</th>
                  <th>Total Units Available</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of report_data">
                <td>{{row.make}}</td>
                <td>{{row.model}}</td>
                <td>{{row.units_in_stock}}</td>
                <td>{{row.units_at_cfs}}</td>
                <td>{{row.units_enroute}}</td>
                <td>{{row.total_units_avail}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.card-body -->
      </div>
    </div>
  </section>
